/******************************************************************************
 * App Hook
 * version: 1.0.2, release: 27.02.2021
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

import React, { useEffect, useState, useRef } from 'react';
import { ButtonBar, HBox, ListView, VBox, TreeView, PageView, Image, Loading, Version, Box } from './lib.r2/ui/ui-controls';
import './App.scss';
import Store from './Store';

import JsonView2 from './lib.r2/views/jsonview/JsonView2';
import Scene3D from './scenes/Scene3D';
import AppOverlay from './AppOverlay';
// import SceneTest from './scenes/SceneTest';


//============================================================================= App Hook
export default function App() {
	const [dataView, setDataView] = useState(false)

	const [versionString, loadError, strategyData] = Store.use('versionString', 'loadError', 'strategy')

	
	useEffect(() => {
		console.log('---init App');
		Store.init()

		return () => {};	//cleanup
	}, []);


	// if (loadError) return <Loading title={'ERROR! ' + loadError}  />

	// if (!strategyData) return <Loading spinner title={'loading strategy data ...'}  />

	return (
		<div id='app'>
			<img className='app-background' src='assets/background.png' alt='' />

			{/* <img className='app-logo' src={'assets/app-logo.png'} alt='' /> */}

			{strategyData?.client?.logoAsset?.thumb_url &&
				<img className='app-logo' src={strategyData.client.logoAsset.thumb_url} alt='' />
			}

			{loadError ?
				<Loading title={'ERROR! ' + loadError}  />
				: !strategyData?
				<Loading spinner title={'loading strategy data ...'}  />
				:
				<>
					<Scene3D data={strategyData} />

					<AppOverlay />

					{dataView &&
						<JsonView2 id='app-data-view' sourceData={strategyData} />
					}

					<div className='app-data-view-switch' onClick={e => {
						setDataView(!dataView)
					// }}>{dataView? '✖' : '...'}</div>
					}}>{dataView? '✖' : ''}</div>
				</>
			}

			<Version value={versionString} />
		</div>
	);
}
